moya = window.moya || {};

moya.sitemap = {};

moya.sitemap.init = function () {
	if (console && console.log) {
		console.log('moya.sitemap.init() is deprecated')
	}
};
